import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { ContaContabil } from '../interface/conta-contabil';

@Injectable({
  providedIn: 'root'
})
export class ContaContabilLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrcontabilidade/contacontabil`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<ContaContabil> {
    return this.httpClient.get<ContaContabil>(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CCT1CONTA' , optional: true, gridColumns: 6, label: 'Codigo'},
      {property: 'CCT1DESC01', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CCT1CONTA' , label: 'Código'},
      {property: 'CCT1DESC01', label: 'Descrição'},
    ];
  }

  getFieldFormater(value: ContaContabil): string {
    return `${value.CCT1CONTA} - ${value.CCT1DESC01}`;
  }
}
